var _circle, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 26,
    viewBox: "0 0 9 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4,
    r: 4,
    fill: "#9966FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 10,
    width: 2,
    height: 16,
    rx: 1,
    fill: "#9966FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 12,
    width: 3,
    height: 12,
    rx: 1.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12,
    width: 3,
    height: 12,
    rx: 1.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicator);
export default __webpack_public_path__ + "static/media/indicator.311cfccc9d51e2161e56d8aad07849d4.svg";
export { ForwardRef as ReactComponent };